import { baseApi } from "./baseApi";

const DELIVERY_BASE_URL = "/deliveries";

export const deliveryApi = baseApi.injectEndpoints({
  tagTypes: ["Delivery"],

  endpoints: (build) => ({
    addDelivery: build.mutation({
      query: (body) => ({
        url: DELIVERY_BASE_URL,
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "Delivery", id: "LIST" }],
    }),

    listDelivery: build.query({
      query: (params) => ({
        url: DELIVERY_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result.data.map(({ _id }) => ({
              type: "Delivery",
              id: _id,
            })),
            { type: "Delivery", id: "LIST" },
          ]
          : [{ type: "Delivery", id: "LIST" }],
    }),
    listDeliveriesForDriver: build.query({
      query: (params) => ({
        url: `${DELIVERY_BASE_URL}/listDeliveriesForDriver`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result.data.map(({ _id }) => ({
              type: "Delivery",
              id: _id,
            })),
            { type: "Delivery", id: "LIST" },
          ]
          : [{ type: "Delivery", id: "LIST" }],
    }),

    getDDLDeliveryList: build.query({
      query: (params) => ({
        url: `${DELIVERY_BASE_URL}/ddl`,
        params,
      }),
      providesTags: (result) =>
        result
          ? [
            ...result.map(({ id }) => ({
              type: "Delivery",
              id,
            })),
            { type: "Delivery", id: "DDL" },
          ]
          : [{ type: "Delivery", id: "DDL" }],
    }),

    getDDLForShipmentDeliveryCollectionList: build.query({
      query: (params) => ({
        url: `${DELIVERY_BASE_URL}/ddlForShipmentDeliveryCollection`,
        params,
      }),
      providesTags: (result) =>
        result
          ? [
            ...result.map(({ id }) => ({
              type: "Delivery",
              id,
            })),
            { type: "Delivery", id: "DDL" },
          ]
          : [{ type: "Delivery", id: "DDL" }],
    }),

    getDdlShipmentForBranchDelivery: build.query({
      query: (params) => ({
        url: `${DELIVERY_BASE_URL}/ShipmentForBranchDelivery`,
        params,
      }),
      providesTags: (result) =>
        result
          ? [
            ...result.map(({ id }) => ({
              type: "Delivery",
              id,
            })),
            { type: "Delivery", id: "DDL" },
          ]
          : [{ type: "Delivery", id: "DDL" }],
    }),

    getDeliveryDetail: build.query({
      query: (deliveryId) => `${DELIVERY_BASE_URL}/${deliveryId}`,
      providesTags: (result, error, { _id }) => [
        { type: "Delivery", id: _id },
        { type: "Delivery", id: "LIST" },
      ],
    }),

    getDeliveryDetailByShipmentId: build.query({
      query: (shipmentId) => `/deliveries/shipment/${shipmentId}`,
      providesTags: (result) =>
        result
          ? [
            { type: "Delivery", id: result._id },
            { type: "Delivery", id: "LIST" },
          ]
          : [{ type: "Delivery", id: "LIST" }],
    }),

    updateDelivery: build.mutation({
      query: ({ _id, ...body }) => ({
        url: `${DELIVERY_BASE_URL}/${_id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, { _id: id }) => [
        { type: "Delivery", id },
        { type: "Delivery", id: "LIST" },
      ],
    }),

    listShipmentsByDeliveryId: build.query({
      query: ({ deliveryId, page, limit }) => ({
        url: `${DELIVERY_BASE_URL}/${deliveryId}/shipments`,
        params: { page, limit },
      }),
      providesTags: (_result, _error, { _id }) => [
        { type: "Delivery", id: _id },
        { type: "Delivery", id: "LIST" },
      ],
    }),
    getDDLWarehouseListDelivery: build.query({
      query: (params) => ({
        url: `${DELIVERY_BASE_URL}/warehouse-ddl`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result.data.map(({ _id }) => ({
              type: "Delivery",
              id: _id,
            })),
            { type: "Delivery", id: "WAREHOUSE_DDL" },
          ]
          : [{ type: "Delivery", id: "WAREHOUSE_DDL" }],
    }),
    getWarehouseShipmentsDelivery: build.query({
      query: (params) => ({
        url: `${DELIVERY_BASE_URL}/warehouse-shipments`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result.data.map(({ _id }) => ({
              type: "Delivery",
              id: _id,
            })),
            { type: "Delivery", id: "WAREHOUSE_SHIPMENTS" },
          ]
          : [{ type: "Delivery", id: "WAREHOUSE_SHIPMENTS" }],
    }),
    getDDLSendOutForDelivery: build.query({
      query: (params) => ({
        url: `${DELIVERY_BASE_URL}/sendOutDdlForDelivery`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result.data.map(({ _id }) => ({
              type: "SendOut",
              id: _id,
            })),
            { type: "SendOut", id: "DDL" },
          ]
          : [{ type: "SendOut", id: "DDL" }],
    }),
    downloadDeliveriesByDriver: build.query({
      query: ({ driverId, fromDate, toDate }) => ({
        url: `${DELIVERY_BASE_URL}/download-by-driver`,
        params: { driverId, fromDate, toDate },
      }),
    }),

    shipmentForDeliveryCollectionSearch: build.query({
      query: ({ account, entity, query }) => ({
        url: `${DELIVERY_BASE_URL}/search`,
        params: { account, entity, query },
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result?.data?.map(({ _id }) => ({
              type: "VendorProfile",
              _id,
            })),
            { type: "VendorProfile", id: "SEARCH" },
          ]
          : [{ type: "VendorProfile", id: "SEARCH" }],
    }),
  }),

  overrideExisting: false,
});

export const {
  useListDeliveryQuery,
  useLazyListDeliveryQuery,
  useLazyListDeliveriesForDriverQuery,
  useAddDeliveryMutation,
  useLazyGetDDLDeliveryListQuery,
  useLazyGetDDLForShipmentDeliveryCollectionListQuery,
  useGetDeliveryDetailQuery,
  useGetDeliveryDetailByShipmentIdQuery,
  useUpdateDeliveryMutation,
  useLazyDownloadDeliveriesByDriverQuery,
  useListShipmentsByDeliveryIdQuery,
  useLazyListShipmentsByDeliveryIdQuery,
  //warehouse ddl
  useGetDDLWarehouseListDeliveryQuery,
  useLazyGetDDLWarehouseListDeliveryQuery,
  useGetWarehouseShipmentsDeliveryQuery,
  useLazyGetWarehouseShipmentsDeliveryQuery,
  useLazyGetDDLSendOutForDeliveryQuery,
  useLazyGetDdlShipmentForBranchDeliveryQuery,
  useLazyShipmentForDeliveryCollectionSearchQuery,
} = deliveryApi;
